import React, { Component } from "react";

import Icon from "@mdi/react";
// import Live from "./matchlisting/Live";
import { mdiTwitch } from "@mdi/js";

type Props = { transparent: boolean };
type State = {};

export default class ScoreHero extends Component<Props, State> {
  static defaultProps: Props = { transparent: false };

  render() {
    return (
      <div
        className={
          this.props.transparent
            ? "bg-transparent z-10 relative"
            : "bg-gray-800 z-10 relative"
        }
      >
        <div className="relative max-w-4xl mx-auto p-8 py-16">
          <div className="absolute right-0">
            {/* <Live /> */}
            <div
              className="flex flex-shrink items-center bg-opacity-20 px-2 py-1 rounded-md mr-2"
              style={{ backgroundColor: "#00FF0033" }}
            >
              <span className="font-bold" style={{ color: "#0F0" }}>
                Win
              </span>
            </div>
          </div>

          <div className="flex flex-col items-center">
            <div className="text-center h-12 w-12 sm:h-16 sm:w-16 text-white mb-2">
              <R6 />
            </div>
            <div className="text-center font-header font-medium text-lg sm:text-2xl text-white">
              Collegiate R6 Stage 3 Match 1
            </div>
            <div className="flex flex-wrap md:flex-nowrap flex-row mt-8 justify-center items-center">
              <div className="text-left md:text-right mb-4 px-4 md:px-0 w-1/2 md:w-64">
                <div className="font-header text-base sm:text-2xl font-bold text-brownu-lightred">
                  Brown Esports
                </div>
                <div className="font-header text-xs sm:text-sm text-gray-400">
                  R6 Siege Red
                </div>
              </div>
              <div className="inline-flex flex-row order-first md:order-none w-screen md:w-auto items-center justify-center">
                <div className="text-9xl font-header font-bold text-brownu-lightred text-right md:w-32 lg:w-52 xl:w-64">
                  2
                </div>
                <div className="text-9xl font-header font-bold text-gray-600 mx-2 -mt-6">
                  :
                </div>
                <div className="text-9xl font-header font-bold text-brownu-taupe text-left md:w-32 lg:w-52 xl:w-64">
                  0
                </div>
              </div>
              <div className="text-right md:text-left mb-4 px-4 md:px-0 w-1/2 md:w-64">
                <div className="font-header text-base sm:text-2xl font-bold text-brownu-taupe">
                  North Carolina State University
                </div>
                <div className="font-header text-xs sm:text-sm text-gray-400">
                  A Team
                </div>
              </div>
            </div>
            <div className="text-center font-header font-medium text-xl text-gray-200 mb-6">
              Feb 18 @ 8:00pm
            </div>
            <button className="flex flex-shrink items-center px-2 py-1 rounded-md bg-[#9146FF33] hover:bg-[#9146FF50] transition-all duration-200">
              <span
                className="font-medium font-body tracking-wide -mb-1"
                style={{ color: "#9146FF" }}
              >
                No VOD Available
              </span>
              <span className="ml-2">
                <Icon path={mdiTwitch} size={1} style={{ color: "#9146FF" }} />
              </span>
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const R6 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 50 50"
      fill="currentColor"
    >
      <path d="M 23.900391 2.0234375 C 22.878391 2.0234375 21.101875 2.1171094 19.296875 2.6621094 C 17.701875 3.1431094 16.395063 3.8796562 15.414062 4.8476562 C 14.189063 6.0556563 13.469391 7.6312031 13.275391 9.5332031 L 13.275391 9.5351562 L 13.275391 40.677734 C 13.273391 40.710734 13.243453 41.305906 13.439453 42.128906 C 13.624453 42.905906 14.055547 44.054469 15.060547 45.105469 C 15.901547 45.984469 17.013141 46.668672 18.369141 47.138672 C 19.865141 47.657672 21.674953 47.919922 23.751953 47.919922 C 23.936953 47.919922 24.1235 47.918062 24.3125 47.914062 C 24.3575 47.919063 24.910953 47.980469 25.751953 47.980469 C 26.763953 47.980469 28.192203 47.891719 29.658203 47.511719 C 31.260203 47.096719 32.592188 46.419047 33.617188 45.498047 C 34.899188 44.345047 35.701 42.809641 36 40.931641 L 36 40.929688 L 36 21.134766 L 35.998047 21.126953 C 35.996047 21.116953 35.783078 20.091031 34.705078 19.082031 C 34.073078 18.491031 33.272219 18.020594 32.324219 17.683594 C 31.141219 17.262594 29.724281 17.050781 28.113281 17.050781 C 28.110281 17.050781 28.048406 17.048828 27.941406 17.048828 C 27.562406 17.048828 26.612344 17.063359 25.652344 17.193359 C 24.927344 17.291359 24.338344 17.436094 23.902344 17.621094 C 23.468344 17.806094 23.183734 18.034734 23.052734 18.302734 L 23.003906 10.753906 C 23.085906 10.666906 23.6855 10.066578 24.5625 10.017578 C 24.6015 10.015578 24.639734 10.013672 24.677734 10.013672 C 25.284734 10.013672 25.887562 10.280641 26.476562 10.806641 L 26.435547 14.548828 C 26.430547 15.059828 26.844469 15.476562 27.355469 15.476562 L 35.080078 15.476562 C 35.588078 15.476562 35.998047 15.064641 35.998047 14.556641 L 35.998047 9.5351562 C 35.998047 9.5281563 35.994891 8.8423437 35.712891 7.9023438 C 35.452891 7.0343437 34.898469 5.7644844 33.730469 4.6464844 C 32.841469 3.7944844 31.717625 3.140125 30.390625 2.703125 C 29.034625 2.256125 27.448016 2.03125 25.666016 2.03125 C 25.375016 2.03125 25.079344 2.0387812 24.777344 2.0507812 C 24.736344 2.0477812 24.414391 2.0234375 23.900391 2.0234375 z M 29.869141 25.716797 C 30.056953 25.724438 30.218672 25.754922 30.357422 25.794922 C 30.905422 25.952922 31.191281 26.296422 31.238281 26.357422 L 31.238281 29.861328 C 29.666281 29.865328 28.475 30.096063 27.75 30.289062 C 26.957 30.501062 26.533297 30.71675 26.529297 30.71875 L 26.509766 30.728516 L 26.509766 34.59375 C 25.537766 34.48075 24.853219 34.716547 24.449219 34.935547 C 24.003219 35.177547 23.795109 35.444078 23.787109 35.455078 L 23.779297 35.466797 L 23.779297 42.876953 L 23.476562 42.876953 L 23.476562 43.189453 L 21.271484 43.189453 L 21.271484 42.910156 L 20.511719 42.910156 L 20.511719 42.216797 L 20.802734 42.216797 L 20.802734 27.882812 L 20.791016 27.648438 L 20.515625 27.648438 L 20.515625 27.142578 L 20.787109 27.142578 L 20.787109 26.617188 L 21.349609 26.617188 L 21.349609 26.369141 L 23.785156 26.369141 C 23.921156 26.746141 24.168578 27.005625 24.517578 27.140625 C 24.988578 27.322625 25.6355 27.281578 26.4375 27.017578 C 27.0325 26.821578 27.496 26.569406 27.5 26.566406 L 27.503906 26.564453 C 28.520156 25.869203 29.305703 25.693875 29.869141 25.716797 z M 25.421875 30.708984 L 25.4375 31.294922 L 25.46875 31.298828 C 25.47375 31.299828 25.951344 31.387828 26.027344 31.673828 L 25.876953 31.816406 C 25.866953 31.804406 25.854891 31.788484 25.837891 31.771484 C 25.681891 31.609484 25.08925 31.155422 24.03125 32.107422 L 24.019531 32.119141 L 24.019531 34.359375 L 26.326172 34.359375 L 26.326172 31.285156 L 25.998047 30.708984 L 25.421875 30.708984 z"></path>
    </svg>
  );
};
